import React, { useRef } from 'react';

import { useOutsideClick } from '../../../utils/custom-hooks';

import smallX from '../../../images/icons/X-small.png';

import './modal-wrapper.scss';
import { getClass } from '../../../utils/component-helpers';

const ModalWrapper = ({ children, closeModal, showX, flexHeight }) => {
  const modal = useRef(null);

  useOutsideClick(modal, closeModal);
  const xIcon = showX ? (
    <img src={smallX} className="close-btn" alt="close" onClick={closeModal} />
  ) : null;

  return (
    <div className="modal-wrapper">
      <div
        className={getClass('modal', 'movable-right', { 'flex-height': flexHeight })}
        ref={node => (modal.current = node)}
        onClick={e => e.stopPropagation()}
      >
        {xIcon}
        {children}
      </div>
    </div>
  );
};

export default ModalWrapper;
